'use strict';

var moment = require('moment');

exports.isAvailable = function (_ref) {
  var calendar = _ref.calendar,
      date = _ref.date,
      times = _ref.times;

  var _date = moment(date).format('YYYY-MM-DD');
  var events = calendar.availability[_date];

  if (!events) {
    return true;
  }

  /* Instead of checking to see if the times satisfy all the conditions of conflict, we check the conditions for no conflict and invert that.
  If this seems confusing at first, that's because it is ;)
  Check out this answer on SO for more detail
  https://stackoverflow.com/questions/143552/comparing-date-ranges/143568#143568
  */

  return !exports.findConflict({ events: events, times: times });
};

exports.getEvents = function (_ref2) {
  var calendar = _ref2.calendar,
      date = _ref2.date;

  var _date = moment(date).format('YYYY-MM-DD');
  return calendar.availability[_date] ? calendar.availability[_date] : [];
};

exports.findConflict = function (_ref3) {
  var events = _ref3.events,
      times = _ref3.times;

  return events.find(function (savedEvent) {
    return times.startTime < savedEvent.endTime && times.endTime > savedEvent.startTime;
  });
};